export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";